$(window).on("scroll", function () {
    const button = $(".js-scroll-to-top-button");
    if ($(window).scrollTop() > 100) {
        button.removeClass('d-none');
        button.addClass('d-block d-sm-none');
    } else {
        button.removeClass('d-block d-sm-none');
        button.addClass('d-none');
    }
});

$(".js-scroll-to-top-button").on("click", function () {
    $('html, body').animate({scrollTop: 0}, 'smooth');
});